import React, { ReactElement } from "react";
import { ResourcePickerPopover } from "@jugl-web/ui-components/web/ResourcePickerPopover";
import { DotIcon, RenderTriggerProps } from "@jugl-web/ui-components";
import { FormField } from "@jugl-web/rest-api";
import {
  useTranslations,
  convertSnakeCaseToReadableString,
  useAppVariant,
} from "@jugl-web/utils";

export interface CustomerDropdownPickerProps {
  field: FormField;
  controlledField: {
    value: string;
    onChange: (value: string | null) => void;
  };
  renderTrigger: (props: RenderTriggerProps) => ReactElement;
}

export const CustomerDropdownPicker: React.FC<CustomerDropdownPickerProps> = ({
  field,
  controlledField,
  renderTrigger,
}) => {
  const { t } = useTranslations();
  const { isMobile } = useAppVariant();
  const listItems = [
    {
      id: "none",
      value: null,
      color: "#BDBDBD",
    },
    ...(field.values?.map((item) => ({
      id: item.id,
      value: item.value,
      color: item.color,
    })) || []),
  ];

  return (
    <ResourcePickerPopover
      title={
        <div className="font-secondary">
          {convertSnakeCaseToReadableString(field.name)}
        </div>
      }
      className="w-[340px]"
      placement="top-end"
      items={listItems}
      selectionBehavior={{ mode: "single", canToggle: false }}
      hasSearch
      defaultSelectedIds={
        controlledField.value ? [controlledField.value] : ["none"]
      }
      maxVisibleItems={isMobile ? 3 : 5}
      itemSize="lg"
      spaceBetweenItems="compact"
      renderLabel={(item) => {
        const label = listItems.find((v) => v.value === item.value)?.value;
        if (item.id === "none") {
          return t({
            id: "common.none",
            defaultMessage: "None",
          });
        }
        if (label) {
          return label;
        }
        return item.id;
      }}
      renderStartIcon={(item) => (
        <DotIcon
          color={
            listItems.find((fieldValue) => fieldValue.value === item.value)
              ?.color || ""
          }
        />
      )}
      renderTrigger={renderTrigger}
      onSelect={({ item, onClose }) => {
        controlledField.onChange(item.id === "none" ? null : item.id);
        onClose();
      }}
    />
  );
};
